export default __webpack_public_path__ + "static/media/loading-refresh.8976c180.gif";